// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetSemanticTagDrawerQuery,
    BaseResponseListSemanticDrawerResponse,
} from '../../types';

/**
 * getDrawer
 *
 * @export
 * @tags semantic-tag-controller
 * @link [GET] /semantic-tag/drawer
 */
export function getSemanticTagDrawer(
    options: ApiOptions<never, GetSemanticTagDrawerQuery> & { params: GetSemanticTagDrawerQuery }
): Promise<BaseResponseListSemanticDrawerResponse> {
    return request<never, never, GetSemanticTagDrawerQuery>('/semantic-tag/drawer', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getSemanticTagDrawer',
    });
}

export const meta = [
    { tags: ['semantic-tag-controller'], path: '/semantic-tag/drawer', method: 'get' },
];
